import { useState, useEffect, useCallback } from 'react';
import { OperationMS } from '../types';
import { getOperationMs } from '../services/operationMsService';

// Fetch de l'operation MS acheteur (via le service), avec refetch (remplace les
// window.location.reload des popups de l'ancienne page).
export const useOperationMsData = (id?: string) => {
  const [operation, setOperation] = useState<OperationMS | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOperation = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      setOperation(await getOperationMs(id));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur de chargement');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOperation();
  }, [fetchOperation]);

  return { operation, loading, error, refetch: fetchOperation, setOperation };
};
